import { useContext } from 'react';
import type { FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';
import emojiRegex from 'emoji-regex';
import { getEmojiDataFromNative, Emoji } from 'emoji-mart';
import type { Data as NativeData } from 'emoji-mart';
import data from 'emoji-mart/data/all.json';

import type { BaseProps, NoChildrenProp } from '../../types';
import { replaceMatchWithElement } from '../../utils';

import { EmojiContext } from './EmojiPicker';

export interface EmojiDisplayProps extends BaseProps, NoChildrenProp {
  /** Content to be displayed */
  content: ReactNode;
  /** Size of emoji */
  size?: number;
}
const StyledEmojiDisplay = styled.span`
  .emoji-mart-emoji {
    line-height: 1;
    vertical-align: middle;
  }
`;
const EmojiDisplay: FunctionComponent<EmojiDisplayProps> = props => {
  const { content, size = 20, ...restProps } = props;
  const regex = emojiRegex();
  let msgArr: JSX.Element[] = [];
  const { set: emojiSet } = useContext(EmojiContext);
  if (typeof content === 'string' && emojiSet) {
    const renderEmoji = (eMatch: string) => {
      const emojiData = getEmojiDataFromNative(eMatch, emojiSet, data as unknown as NativeData);
      return emojiData && <Emoji set={emojiSet} emoji={emojiData} size={size} />;
    };
    if (content.split(regex).length > 1) {
      msgArr = replaceMatchWithElement(content, regex, renderEmoji);
    }
  }
  return emojiSet && msgArr.length >= 1 ? (
    <StyledEmojiDisplay {...restProps}>{msgArr}</StyledEmojiDisplay>
  ) : (
    <>{content}</>
  );
};
export default EmojiDisplay;
